<template>
  <StdSplitpane>
    <StdPane>
      <StdPageForm>
        <vh-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
          <vh-form-item label="标题" prop="title">
            <vh-input
              v-model="ruleForm.title"
              placeholder="请输入标题"
              maxlength="100"
              show-word-limit
            ></vh-input>
          </vh-form-item>
          <vh-form-item label="参与条件" prop="active_rule_cardinal">
            <vh-radio-group
              v-model="ruleForm.active_rule_cardinal"
              @change="changeActiveRuleCardinal"
            >
              <vh-radio :label="1" v-if="type != 1" class="lh-20">无条件（全体参会者）</vh-radio>
              <vh-radio :label="2" class="lh-20">
                观看
                <vh-select
                  v-model="ruleForm.viewing_minutes"
                  style="display: inline-block; width: 90px"
                >
                  <vh-option
                    v-for="(num, index) in new Array(16).fill().map((_, i) => (i + 1) * 5 + '')"
                    :key="index"
                    :label="num + '分钟'"
                    :value="num"
                  ></vh-option>
                </vh-select>
                可自动领取
              </vh-radio>
            </vh-radio-group>
          </vh-form-item>
          <vh-form-item label="设置奖励" prop="awardList">
            <vh-button icon="vh-icon-circle-plus-outline" plain round @click="selectAwards">
              选择奖励
            </vh-button>
            <RewardDialog
              ref="rewardDialog"
              @onSelected="onSelectedAwards"
              :selected="ruleForm.awardList"
            ></RewardDialog>
            <vh-table
              class="selected_award_list"
              :data="ruleForm.awardList"
              size="mini"
              v-if="ruleForm.awardList.length > 0"
            >
              <vh-table-column label="ID" prop="id" width="60px"></vh-table-column>
              <vh-table-column label="标题" prop="title">
                <template slot-scope="scope">
                  <vh-tooltip effect="dark" placement="top-start" :content="scope.row.title">
                    <div class="custom-tooltip-content two-lines-ellipsis">
                      {{ scope.row.title }}
                    </div>
                  </vh-tooltip>
                </template>
              </vh-table-column>
              <vh-table-column label="类型" prop="award_type"></vh-table-column>
              <vh-table-column label="其他说明" prop="remark">
                <template slot-scope="scope">
                  <vh-tooltip effect="dark" placement="top-start" :content="scope.row.remark">
                    <div class="custom-tooltip-content two-lines-ellipsis">
                      {{ scope.row.remark }}
                    </div>
                  </vh-tooltip>
                </template>
              </vh-table-column>
              <vh-table-column label="操作" width="70px">
                <template slot-scope="scope">
                  <vh-button type="text" @click="removeAward(scope.row)">移除</vh-button>
                </template>
              </vh-table-column>
            </vh-table>
          </vh-form-item>
          <vh-form-item label="发放数量" prop="quantity">
            <vh-input
              style="width: 160px"
              type="number"
              placeholder="请输入数量"
              v-model.number="ruleForm.quantity"
            >
              <template slot="append">个</template>
            </vh-input>
          </vh-form-item>
          <vh-form-item label="提示效果" prop="tip_mode">
            <vh-radio-group v-model="ruleForm.tip_mode" @change="handleGrantTypeChange">
              <vh-radio-card :label="1" class="lh-20">
                <img class="effect_icon" src="./img/reward_effect1.png" alt="" />
              </vh-radio-card>
              <vh-radio-card :label="2" class="lh-20">
                <img class="effect_icon" src="./img/reward_effect2.png" alt="" />
              </vh-radio-card>
              <vh-radio-card :label="3" class="lh-20">
                <img class="effect_icon" src="./img/reward_effect3.png" alt="" />
              </vh-radio-card>
            </vh-radio-group>
          </vh-form-item>
          <vh-form-item label="提示方式" prop="display_of_results">
            <vh-radio-group v-model="ruleForm.display_of_results" @change="handleGrantTypeChange">
              <vh-radio :label="0" class="lh-20">全屏弹出</vh-radio>
              <vh-radio :label="1" class="lh-20" v-if="ruleForm.active_rule_cardinal == 1">
                右下角气泡
              </vh-radio>
            </vh-radio-group>
          </vh-form-item>
          <vh-form-item label="设置文案" prop="tip_setting.title">
            <vh-input
              v-model="ruleForm.tip_setting.title"
              placeholder="请输入奖励标题"
              maxlength="10"
              show-word-limit
            ></vh-input>
          </vh-form-item>
          <vh-form-item>
            <vh-input
              v-model="ruleForm.tip_setting.description"
              placeholder="请输入奖励描述"
              maxlength="15"
              show-word-limit
            ></vh-input>
          </vh-form-item>
          <!-- <vh-form-item
        label="回放领取"
        prop="record_support"
        v-if="ruleForm.active_rule_cardinal == 2 && type != 2"
      >
        <vh-radio-group v-model="ruleForm.record_support">
          <vh-radio :label="1" class="lh-20">否</vh-radio>
          <vh-radio :label="2" class="lh-20">是</vh-radio>
        </vh-radio-group>
      </vh-form-item> -->
          <vh-form-item>
            <vh-button round type="primary" @click="submitForm('ruleForm')">保存</vh-button>
          </vh-form-item>
        </vh-form>
      </StdPageForm>
    </StdPane>
    <StdSimulatorPreview :hasMask="ruleForm.display_of_results == 0">
      <!-- TODO：跟随左侧内容变化 -->
      <div
        :class="[
          'mobile_preview',
          'preview',
          'preview' + ruleForm.tip_mode,
          'result_mode' + ruleForm.display_of_results
        ]"
        slot="mobile"
      >
        <img
          :src="
            require(`./img/reward_effect${ruleForm.display_of_results == 0 ? '_pre' : ''}${
              ruleForm.tip_mode
            }.png`)
          "
          alt=""
        />
        <div class="preview_content">
          <p class="title">{{ ruleForm.tip_setting.title }}</p>
          <span class="accept_btn">
            {{ ruleForm.display_of_results == 1 ? '立即领取' : '开心收下' }}
          </span>
          <p class="desc">{{ ruleForm.tip_setting.description }}</p>
        </div>
      </div>
      <div
        :class="[
          'pc_preview',
          'preview',
          'preview' + ruleForm.tip_mode,
          'result_mode' + ruleForm.display_of_results
        ]"
        slot="pc"
      >
        <img
          :src="
            require(`./img/reward_effect${ruleForm.display_of_results == 0 ? '_pre' : ''}${
              ruleForm.tip_mode
            }.png`)
          "
          alt=""
        />
        <div class="preview_content">
          <p class="title">{{ ruleForm.tip_setting.title }}</p>
          <span class="accept_btn">
            {{ ruleForm.display_of_results == 1 ? '立即领取' : '开心收下' }}
          </span>
          <p class="desc">{{ ruleForm.tip_setting.description }}</p>
        </div>
      </div>
    </StdSimulatorPreview>
  </StdSplitpane>
</template>

<script>
  import { getMallRewardInfo, createMallReward, saveMallReward } from '../common/api';
  import RewardDialog from './components/RewardDialog.vue';
  import { throttle } from 'lodash';
  export default {
    props: {
      webinarId: {},
      mallRewardId: {},
      type: {}
    },
    components: {
      RewardDialog
    },
    data() {
      return {
        ruleForm: {
          title: '', // 标题
          active_rule_cardinal: this.type != 1 ? 1 : 2, // 参与条件 1 无条件、 2 根据观看时长参与
          viewing_minutes: '45', // 观看分钟数（参与条件）
          tip_mode: 1, //提示效果，1、2、3
          display_of_results: this.type != 1 ? 1 : 0, //0全屏展示，1右下角展示
          quantity: undefined, //发放数量
          // record_support: this.type != 2 ? 1 : undefined, //回放领取方式 1 不支持 2 支持
          tip_setting: {
            title: '',
            description: ''
          },
          awardList: []
        },
        custom_minute: '',
        rules: {
          title: [
            { required: true, message: '请输入标题', trigger: 'blur' },
            { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
          ],
          awardList: [
            { required: true, message: '请选择奖励', trigger: 'change' },
            {
              validator: (rule, value, callback) => {
                if (value.length == 0) {
                  callback(new Error('请选择奖励'));
                } else {
                  callback();
                }
              },
              trigger: 'change'
            }
          ],

          quantity: [
            { required: true, message: '请输入发放数量', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (!/^[1-9]\d*$/.test(value)) {
                  callback(new Error('请输入正整数'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ],
          'tip_setting.title': [{ required: true, message: '请输入标题', trigger: 'blur' }]
        }
      };
    },
    methods: {
      changeActiveRuleCardinal() {
        if (this.ruleForm.active_rule_cardinal == 2) {
          this.ruleForm.display_of_results = 0;
        } else {
          this.ruleForm.display_of_results = 1;
        }
      },
      selectAwards() {
        this.$refs.rewardDialog.openDialog();
      },
      onSelectedAwards(val) {
        this.ruleForm.awardList = val;
        this.$refs.ruleForm.validateField('awardList');
      },
      removeAward(row) {
        this.ruleForm.awardList = this.ruleForm.awardList.filter(item => item.id != row.id);
        this.$refs.ruleForm.validateField('awardList');
      },
      handleGrantTypeChange() {
        if (this.ruleForm.grant_type == 1) {
          this.ruleForm.total_amount = undefined;
        } else {
          this.ruleForm.each_amount = undefined;
        }
      },
      liveModeChange(index) {
        this.ruleForm.liveMode = index;
      },
      handleNodelaySelect() {
        this.ruleForm.noDelay = !this.ruleForm.noDelay;
      },
      submitForm: throttle(
        function (formName) {
          this.$refs[formName].validate(valid => {
            if (valid) {
              const {
                title,
                active_rule_cardinal,
                viewing_minutes,
                tip_mode,
                display_of_results,
                quantity,
                tip_setting,
                awardList
              } = this.ruleForm;
              const params = {
                webinar_id: this.webinarId,
                type: this.type + '' || '1', //  1 直播 2 回放
                title,
                viewing_minutes: active_rule_cardinal == 2 ? viewing_minutes : 0,
                tip_mode,
                display_of_results,
                award_ids: awardList.map(item => item.id).join(','),
                quantity,
                tip_setting: JSON.stringify(tip_setting)
              };
              this.mallRewardId && (params.id = this.mallRewardId);
              saveMallReward(params).then(res => {
                if (res.code === 200) {
                  this.$emit('save');
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  });
                } else {
                  this.$message({
                    message: res.msg,
                    type: 'error'
                  });
                }
              });
            }
          });
        },
        3000,
        { trailing: false }
      ),
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      getMallRewardInfo() {
        getMallRewardInfo({ id: this.mallRewardId, webinar_id: this.webinarId }).then(res => {
          if (res.code === 200) {
            const {
              title,
              viewing_minutes,
              tip_mode,
              display_of_results,
              quantity,
              tip_setting,
              award_list
            } = res.data;
            this.ruleForm = {
              title,
              active_rule_cardinal: viewing_minutes > 0 ? 2 : 1,
              viewing_minutes: viewing_minutes > 0 ? viewing_minutes : 45,
              tip_mode: tip_mode,
              display_of_results,
              quantity,
              tip_setting: JSON.parse(tip_setting),
              awardList: award_list
            };
          }
        });
      }
    },
    mounted() {
      this.mallRewardId && this.getMallRewardInfo();
    }
  };
</script>
<style lang="less" scoped>
  .text-mute {
    line-height: 40px;
    color: #8c8c8c;
    font-size: 14px;
  }
  .text-notice {
    line-height: 22px;
    color: #595959;
    font-size: 14px;
  }
  /deep/ .vh-radio-card__inner {
    min-width: 100px;
  }
  .effect_icon {
    width: 100px;
    display: block;
  }
  .selected_award_list {
    line-height: normal;
    margin-top: 10px;
    // /deep/.vh-table__empty-text {
    //   margin: 30px 0;
    // }
  }
  /deep/.std-null-page--search {
    position: absolute;
    transform: translate(-50%, -50%);
    .search {
      margin-top: 0;
      transform: none;
    }
  }
  .preview {
    min-height: auto;
    position: absolute;
    z-index: 100;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 240px;
    }
    &.pc_preview {
      transform: translate(-50%, -50%) scale(0.6);
      &.result_mode1 {
        transform: scale(0.4);
        right: 80px;
      }
    }
    &.result_mode1 {
      transform: scale(0.6);
      top: auto;
      left: auto;
      right: 0px;
      bottom: 50px;
      transform-origin: right bottom;
    }
    &.result_mode0 {
      .preview_content {
        bottom: 50px;
      }
    }
    &.result_mode1 {
      .preview_content {
        bottom: 20px;
      }
    }
    .preview_content {
      position: absolute;
      text-align: center;
      bottom: 50px;
      left: 0;
      right: 0;
      .title {
        color: #fff9e6;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 50px;
      }
      .accept_btn {
        display: block;
        width: 120px;
        height: 36px;
        border-radius: 18px;
        background: #fdd8ac;
        line-height: 36px;
        color: #fb2626;
        font-size: 14px;
        margin: 5px auto;
      }
      .desc {
        height: 22px;
        line-height: 22px;
        margin-top: 5px;
        font-size: 12px;
        color: #fff9e6;
        transform: scale(0.8);
      }
    }
    &.preview3 {
      .preview_content {
        .title {
          color: #fb2626;
          margin-bottom: 30px;
        }
      }
    }
  }
</style>
